const initialState = {
    email: null,
    tokenJWT: null,
}

const userReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'USER_SAVE_DATA':
            return {
                ...state,
                email: action.userData.email,
                tokenJWT: action.userData.tokenJWT,
            }
        case 'USER_SIGN_OUT':
            return {
                ...state,
                tokenJWT: null
            };
        default:
            return state;
    }

}

export default userReducer